import { timeline } from "@/mocks/homeContent";

export default function TimelineSection() {
  return (
    <section id="timeline" className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">时间线还原</p>
            <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{timeline.topic}</h3>
            <p className="mt-4 leading-relaxed text-foreground-600">{timeline.subtitle}</p>
            <div className="mt-6 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-4 py-3 text-sm text-foreground-600">
              <i className="ri-time-line text-primary-600" />
              全程 79 小时 · 6 个关键节点
            </div>
          </div>
        </div>

        <div className="relative lg:col-span-8">
          <span className="absolute bottom-0 left-[7px] top-2 w-px bg-background-300 lg:left-[11px]" />
          <ol className="space-y-0">
            {timeline.nodes.map((n) => (
              <li key={n.time} className="relative flex gap-5 pb-8 last:pb-0 md:gap-8">
                <span className="relative z-10 mt-1 flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full ring-4 ring-background-50 lg:h-5 lg:w-5">
                  <span className="h-full w-full rounded-full bg-accent-500" />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                    <span className="whitespace-nowrap font-heading text-lg font-bold text-primary-600">{n.time}</span>
                    <h4 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">{n.title}</h4>
                  </div>
                  <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{n.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}